var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7806 12.5848L14.0306 19.0648C13.8899 19.1999 13.699 19.2758 13.5 19.2758C13.301 19.2758 13.1101 19.1999 12.9694 19.0648C12.8286 18.9297 12.7496 18.7465 12.7496 18.5554C12.7496 18.3643 12.8286 18.1811 12.9694 18.046L18.4397 12.7954H3.75C3.55109 12.7954 3.36032 12.7195 3.21967 12.5845C3.07902 12.4494 3 12.2664 3 12.0754C3 11.8845 3.07902 11.7013 3.21967 11.5662C3.36032 11.4313 3.55109 11.3554 3.75 11.3554H18.4397L12.9694 6.1048C12.8286 5.9697 12.7496 5.78646 12.7496 5.5954C12.7496 5.40433 12.8286 5.2211 12.9694 5.086C13.1101 4.9509 13.301 4.875 13.5 4.875C13.699 4.875 13.8899 4.9509 14.0306 5.086L20.7806 11.566C20.8504 11.6329 20.9057 11.7123 20.9434 11.7997C20.9812 11.8871 21.0006 11.9808 21.0006 12.0754C21.0006 12.17 20.9812 12.2637 20.9434 12.3511C20.9057 12.4385 20.8504 12.5179 20.7806 12.5848Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/_arrow-right.42a7600c5def2058eb78af618157ae89.svg";
export { ForwardRef as ReactComponent };